import { ReactComponent as ChildIcon } from 'assets/icons/Child.svg';
import { ReactComponent as ChildrenIcon } from 'assets/icons/Children.svg';
import { ReactComponent as GlobusIcon } from 'assets/icons/Globus.svg';
import { ReactComponent as GraphIcon } from 'assets/icons/Graph.svg'
import { ReactComponent as GraphDisabledIcon } from 'assets/icons/GraphDisabled.svg'
import { useSelector } from 'react-redux';
import { AssessementDistribution } from '..';
import { useContext, useMemo } from 'react';
import { ReportContext } from '../ReportContext';
import { StatsBar } from 'components'
import { getSemester } from 'utils/general';

const useViewGraphBtns = () => {
    const { testTaker } = useSelector(state => state.testTaker)
    const { assessment } = useSelector(state => state.assessment)

    const { completedAssessmentCount } = useContext(ReportContext) || {}

    const isDisabeldGraph = completedAssessmentCount?.data < 2 || !completedAssessmentCount?.data

    const viewGraphBtns = useMemo(
        () => [
            {
                key: "single",
                icon: ChildIcon,
                tooltip: testTaker?.first_name,
                placement: "top",
                action: () => { },
                params: {
                    test_taker: assessment.test_taker_id,
                },
                component: StatsBar,
                iconSize: {
                    width: 20,
                    height: 20
                }
            },
            {
                key: "school_class",
                showChildren: true,
                icon: ChildrenIcon,
                placement: "top",
                tooltip: "כל הכיתה",
                action: () => { },
                params: {
                    school_class: testTaker?.school_class,
                    school_year: assessment?.reading_assessment_school_year
                },
                component: StatsBar,
                iconSize: {
                    width: 20,
                    height: 20
                }
            },
            {
                key: "grade",
                tooltip: "כל השכבה",
                showChildren: true,
                placement: "top",
                icon: GlobusIcon,
                action: () => { },
                params: {
                    grade_of_execution: assessment?.reading_assessment_grade_of_execution,
                },
                component: StatsBar,
                iconSize: {
                    width: 20,
                    height: 20
                }
            },
            {
                key: "graph",
                icon: isDisabeldGraph ? GraphDisabledIcon : GraphIcon,
                tooltip: "גרף התקדמות",
                action: () => { },
                placement: "top",
                component: AssessementDistribution,
                disabled: isDisabeldGraph,
                iconSize: {
                    width: 20,
                    height: 20
                }
            },
        ], [testTaker, assessment, completedAssessmentCount]
    )

    return viewGraphBtns

}

export default useViewGraphBtns